import { inject } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { LCPUserService } from '@shared/services/lcp-user/lcp-user.service';
import { take } from 'rxjs';
import { PrevailingWageSetupService } from '../services/prevailing-wage-setup.service';

export const supportAdminSettingResolver: ResolveFn<string> = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {

  const _lcpUserService = inject(LCPUserService);
  const PrevailingWageService = inject(PrevailingWageSetupService);

  const tenantId = _lcpUserService.getUserTenantIdValue();

  if (!tenantId) {
    return null;
  }

  return PrevailingWageService.getSupportAdminSettingPageData(tenantId)
    .pipe(
      take(1)
    ).toPromise();
}


